// components
import { Button } from "../../UI";
// builders
import * as buttonDesignType from "../../../builders/buttonDesign.types";
import { serviceTypeCardBuilder } from "../../../builders/serviceTypeCard.builder";
// icons
import { Trash } from "../../../SVGS";
// styles
import styled from "styled-components";

const ServiceMenuItemStyles = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  .serviceTitle {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    flex: 1;
    margin: 0;
    padding-right: ${({ theme }) => theme.spacing[24]};
  }

  .serviceType {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    width: 160px;
    flex-shrink: 0;
    padding-right: ${({ theme }) => theme.spacing[16]};

    svg {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }
  }

  .availability {
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    width: 120px;
    flex-shrink: 0;
    padding-right: ${({ theme }) => theme.spacing[16]};
  }

  .available {
    color: ${({ theme }) => theme.colors.accent[500]};
  }

  .unavailable {
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .price {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    width: 100px;
    flex-shrink: 0;
  }

  .actions {
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
  }

  .deleteBtn {
    height: 39px;
  }

  .deleteBtn:hover path {
    fill: #ffffff;
  }
`;

const ServiceMenuItem = ({
  serviceType,
  title,
  price,
  available,
  deleteAction,
  editAction
}) => {
  const { Icon } = serviceTypeCardBuilder(serviceType.typeKey);

  return (
    <ServiceMenuItemStyles onClick={editAction}>
      <h3 className="serviceTitle">{title}</h3>
      <span className="serviceType">
        {Icon}
        {serviceType.name}
      </span>
      <span className={`availability ${available ? "available" : "unavailable"}`}>
        {available ? "Available" : "Unavailable"}
      </span>
      <span className="price">$ {price}</span>
      <div className="actions">
        <Button
          onClick={e => {
            e.stopPropagation();
            deleteAction();
          }}
          buttonDesignType={buttonDesignType.DANGER}
          className="deleteBtn"
        >
          <Trash />
        </Button>
      </div>
    </ServiceMenuItemStyles>
  );
};

export default ServiceMenuItem;
